// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8539d013","453":"1dbd2533"}[chunkId] + ".chunk.js";
};